import { ProgressSpinner } from 'primereact/progressspinner'
import styled from 'styled-components'

import logo from 'assets/images/koc-logo.svg'

export default function LoadingWrapper() {
  return (
    <LoadingContainer className={'loading'}>
      <ProgressSpinner style={{ position: 'absolute', width: '120px', zIndex: 1102 }} />
      <img alt="loading-content" style={{ position: 'absolute', width: '60px', zIndex: 1102 }} src={logo} />
    </LoadingContainer>
  )
}

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
  z-index: 1102;
`
